require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/assign.js
// module id = 849
// module chunks = 0